var classof   = require('./$.classof')
  , ITERATOR  = require('./$.wks')('iterator')
  , Iterators = require('./$.iterators');
module.exports = require('./$.core').getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-core/~/core-js/modules/core.get-iterator-method.js
 ** module id = 434
 ** module chunks = 0 1 4 5 6 7 8
 **/